<template>

  <div class="roster-la-reports" >

    <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
      <div class="clearfix row py-2 mb-2 no-margin">
        <div class="col-md-5 pr-0 cursor-pointer text-left pl-0">

          <b-input-group class="from_date-range-picker d-flex flex-row align-items-end justify-content-start">
            <b-form-group id="from_date-group" label-for="from_date" class="mb-0 mr-3"  label="From Date">
              <b-input-group class="mb-0">
                <b-form-input id="from_date" name="from_date" v-model="from_date" v-validate="{  }" type="text" placeholder="YYYY-MM-DD"
                              autocomplete="off" :state="validateState('from_date')" aria-describedby="from_date-feedback" data-vv-as="From Date"/>
                <b-input-group-append class="mb-0">
                  <b-form-datepicker v-b-tooltip.hover.top="'Select a date to preview the report.'" @input="reset" class="mb-0" id="day_two" button-only right locale="en-US" v-model="from_date" />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group id="to_date-group" label-for="to_date" class="mb-0" label="To Date">
              <b-input-group class="mb-0">
                <b-form-input id="to_date" name="to_date" v-model="to_date" v-validate="{  }" type="text" placeholder="YYYY-MM-DD"
                              autocomplete="off" :state="validateState('to_date')" aria-describedby="to_date-feedback" data-vv-as="To Date"/>
                <b-input-group-append class="mb-0">
                  <b-form-datepicker v-b-tooltip.hover.top="'Select a date to preview the report.'" @input="reset" class="mb-0" id="day_two" button-only right locale="en-US" v-model="to_date" />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-input-group>


        </div>
        <div class="col-md-7 no-margin p-0">
          <div class="row d-flex justify-content-end no-margin">
            <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="reset()">Reset</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="previewOrDownloadReport(0)">Preview Report</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="previewOrDownloadReport(1)">Download Report (Excel)</b-button>
          </div>
        </div>
      </div>
      <div v-if="preview" class="monthly-report-wrap">
        <table class="table roster-la-report-table">
          <thead class="table-head">
          <tr>
            <th class="position-sticky">SL</th>
            <th class="position-sticky">Employee Code</th>
            <th class="position-sticky">Employee Name</th>
            <th class="position-sticky">Designation</th>
            <th class="position-sticky">Department</th>
            <th class="position-sticky">Work Location</th>
            <th v-for="date in dates" :key="date">{{ formatHeader(date) }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(employee, index) in preview_data" :key="employee.employee_id">
            <td class="bg-white position-sticky">{{ index + 1 }}</td>
            <td class="bg-white position-sticky">{{ employee.employee_code }}</td>
            <td class="bg-white position-sticky">{{ employee.name }}</td>
            <td class="bg-white position-sticky">{{ employee.designation }}</td>
            <td class="bg-white position-sticky">{{ employee.department }}</td>
            <td class="bg-white position-sticky">{{ employee.branch }}</td>
            <td v-if="flag == 2" v-for="entry in employee.daily_entries" :style="{color: entry.color}">
              <span v-if="entry.shift == null">
                {{entry.text || '-'}}
              </span>
              <span v-else v-b-tooltip.hover.top="`${entry.shift.start_time} - ${entry.shift.end_time}`">
                {{entry.shift.name}} ({{entry.shift.code}})
              </span>
            </td>
            <td v-if="flag == 3" v-for="entry in employee.daily_entries" :style="{color: entry.color}"> {{entry.inout || '-'}}  </td>
            <td v-if="flag == 4" v-for="entry in employee.daily_entries" :style="{color: entry.color}"> {{entry.worktime || '-'}}  </td>
          </tr>
          </tbody>
        </table>

      </div>

      <div v-else class="row" id="assignment">
        <div class="col-12">
          <b-badge class="d-inline mb-3" variant="info">Selected Employee: {{employee_ids.length}}</b-badge>
          <div class="card border-0 no-shadow">
            <common-list :checkbox="1" :is_action="0" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list"
                         :all_employee="'no'" :default_column="default_column" :primary_key="'employee_id'" v-on:childToParent="listReturn"></common-list>
          </div>
        </div>
      </div>

    </b-overlay>
  </div>
</template>


<script>

export default{

  props:['flag'],

  data(){
    const now = new Date();

    let firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    let lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    let format = function(d){
      let year = d.getFullYear();
      let month = ('0' + (d.getMonth() + 1)).slice(-2);
      let day = ('0' + d.getDate()).slice(-2);
      return year + '-' + month + '-' + day;
    };

    return {
      dates:[],
      pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
      selected_date:'',
      date_max:'',
      from_date: format(firstDay),
      to_date: format(lastDay),
      sortKey: 'name',
      checkbox:1,
      is_action:1, /* As this list have actions then is_action will be 1. Otherwise, it will be 0 */
      list_key:0, /* Component Key */
      custom_list:[],  /* Data List */
      default_column:['name','phone','email','jobposition','department','branch','leave_policy','leave_type'], /* Default Column List */
      appended_column:[],
      leave_type_options:[],                /* Appended Column List  and there title and type */
      primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
      company_options:[],         /* Company Filterable options */
      tmp_custom_list:[],
      selected_fiscal_year: '',
      current_fiscal_year: now.getFullYear(),
      employee_ids: [],
      preview_data: '',
      showoverlay : false,
      preview : false,
    }
  },
  methods:{
    reset(){
      this.preview = false;
      this.employee_ids = [];
      this.list_key++;
      this.getEmployees();
    },
    getEmployees() {
      axios.get(this.$api_url + '/leave-attendance/employees/list', { params: {all: this.all,fields:'offday,roster,shift', from: this.from_date, to: this.to_date}}).then(response => {
        this.showoverlay = false;
        if(response.data.error == 1)
          this.notice = response.data.notice;
        else
        {
          this.custom_list = response.data.employee_data;
          this.company_options = response.data.options;
          this.list_key = this.list_key + 1;

        }
      }).catch(e => {
        this.serverError(e);
      });
    },
    formatHeader(dateStr) {
      const options = { day: 'numeric', month: 'short', year: 'numeric' };
      return new Date(dateStr).toLocaleDateString('en-US', options);
    },
    listReturn:function(data)
    {
      this.employee_ids = data.selected;

    },

    previewOrDownloadReport: function(flg)
    {
      if(!this.checkNet()) return false;
      if(this.employee_ids.length == 0)
      {
        if(flg == 1){
          this.$bvToast.toast('Please select employee(s) to download report', {
            title: `Failed`,
            variant: 'danger',
            solid: true
          });
        } else {
          this.$bvToast.toast('Please select employee(s) to generate report', {
            title: `Failed`,
            variant: 'danger',
            solid: true
          });
        }
        return;
      }
      if(flg == 1)
      {
        this.$bvToast.toast('We are downloading the report, this may take a while.', {
          title: `Hold Tight`,
          variant: 'info',
          solid: true
        });
      }

      let config = {};

      if(flg == 1)
      {
        config = {
          responseType: 'blob'
        }
      }

      let fileName = 'Monthly Report Summary';

      switch (flg) {
        case 2: fileName = 'Monthly Attendance Report'; break;
        case 3: fileName = 'Monthly In Out Report'; break;
        case 4: fileName = 'Monthly Working Hour Report'; break;
      }
      // 1 = monthly attendance summary
      // 2 = monthly attendance report
      // 3 = monthly in out report
      // 4 = working hour report

      this.showoverlay = true;

      let formData = new FormData();
      formData.append('employee_ids', JSON.stringify(this.employee_ids));
      formData.append("from_date", this.from_date);
      formData.append("to_date", this.to_date);
      formData.append('is_export', flg);
      formData.append('flag', this.flag);
      axios.post(this.$api_url+'/leave-attendance/report/monthly', formData, config).then(response=>
      {
        this.showoverlay = false;

        if(flg == 0)
        {
          if(this.flag == 1)
          {
            this.preview_data = response.data
          }
          else
          {
            this.preview_data = response.data.attendances;
            this.dates = response.data.dates;
          }
          this.preview = true;
        }
        else if(flg == 1)
        {
          this.global_download_file_content(response);
        }
      }).catch((error) => {
        this.serverError(error);
      });

    },
  },
  computed:
      {
        filteredData()
        {
          let filtered_list = this.custom_list;
          if (this.search)
          {
            filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

            if(filtered_list.length == 0)
              this.blankmsg = "Nothing found.";
          }

          this.people = filtered_list.length;

          return filtered_list;
        },
        paginatedData()
        {
          return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
        selectAll: {
          get: function () {
            if(this.employee_ids.length == 0) return false;
            return this.filteredData ? this.employee_ids.length == this.filteredData.length : false;
          },
          set: function (value) {
            let selected = [];
            if (value) {
              this.filteredData.forEach(function (user) {
                selected.push(user.employee_id);
              });
            }
            this.employee_ids = selected;
          }
        },
      },
  created: function(){
    this.getEmployees();
  }
}
</script>
